import React from "react";
import { PlainTextField } from "@td/ui";
import { translate } from "@td/shared_utils";
import { fieldTypes } from "../constants";

const GroupField = React.memo(() => (
  <PlainTextField
    name={fieldTypes.GROUP}
    label={`${translate(null, "care_team_tasks.form.fields.group", "label")}:`}
  />
));

export default GroupField;
